import { App, AutoComplete, Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Tooltip } from 'antd';
import { FC, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import {
  addPmAdditionalWorkPlaceItem,
  updateEquipmentTab,
  updateField,
} from '../../../../../contextRedux/PMAdditionalAct/PmAdditionalActModel';
import { SearchInput } from '../../../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../../../customComponents/table/CustomTable';
import { RootState } from '../../../../../store';
import { Column } from '../../../../../utils/column';

const { Option } = AutoComplete;

const AddEquipmentTab: FC<any> = ({}) => {
  const isMobile = useMediaQuery({ maxWidth: 720 });
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchRecomandationPieceNumber, setRecomandationPieceNumber] = useState<number>(1);

  const [searchTable, setSearchTable] = useState<string>('');
  const [checkAll, setCheckAll] = useState(false); // "Select All" checkbox state
  const [indeterminate, setIndeterminate] = useState(false);

  const pmAdditionalAct = useSelector((state: RootState) => state.models.pmAdditionalAct);
  const systemTypes = useSelector((state: RootState) => state.store.systemType.data);
  const deviceTypes = useSelector((state: RootState) => state.store.deviceType.data);

  const selectedSystemTypeId = useSelector(
    (state: RootState) => state.models.pmAdditionalAct.equipmentTab.systemTypeId
  );
  const [filtredDeviceTypes, setFiltredDeviceTypes] = useState<any[]>(
    useSelector((state: RootState) =>
      state.store.deviceType.data.filter(
        (d: any) => d.systemTypeId == state.models.pmAdditionalAct.equipmentTab.systemTypeId
      )
    )
  );

  const addedDevices = pmAdditionalAct.pmContractWorkPlaceItems;
  const workPlaces = useSelector((state: RootState) => state.models.pmAdditionalAct.company?.workPlaces);
  const agents = useSelector((state: RootState) => state.models.pmAdditionalAct.company.contactPersons ?? []);

  const handleAddDevice = async (record: any, isFromWorkPlaceItems: boolean = false) => {
    const locations = pmAdditionalAct?.location; // Array of locations in the pmAdditionalAct
    const systemType = form.getFieldValue('systemType');
    const agent = form.getFieldValue('agent');
    let isErrorMessageShown = false;
    let isFilteredErrorMessageShown = false; // New flag for filteredAddedDevice

    for (const location of locations) {
      // Check if the device is already added for this location
      const isDeviceAlreadyAddedForLocation = addedDevices?.some(
        (ad: any) => ad.deviceTypeId === record.id && ad.workPlaceId === location.id
      );

      if (isDeviceAlreadyAddedForLocation) {
        if (!isErrorMessageShown) {
          message.error(<span>{record?.name} este deja adaugat la această locație!</span>);
          isErrorMessageShown = true; // Prevent further error messages for this device
        }
        continue; // Skip this location if the device is already added
      }

      // Check for filteredAddedDevice condition
      const filteredAddedDevice = addedDevices?.filter(
        (ad: any) =>
          ad.workPlace?.name === location?.name &&
          ad.systemType?.name === systemType?.name &&
          ad.interventionPerSystemType !== pmAdditionalAct.equipmentTab.interventionPerSystemType &&
          ad.period !== pmAdditionalAct.equipmentTab.period
      );

      if (filteredAddedDevice?.length > 0) {
        if (!isFilteredErrorMessageShown) {
          message.error(
            <span>
              Nu puteti adauga alt device pe aceeași locație: <b>{filteredAddedDevice[0]?.workPlace?.name}</b>, cu
              același sistem: <b>{filteredAddedDevice[0].systemType?.name}</b> cu o periodicitate diferită de{' '}
              <b>{filteredAddedDevice[0].period}</b> sau un număr de intervenții diferit de{' '}
              <b>{filteredAddedDevice[0].interventionPerSystemType}</b>
            </span>,
            20
          );
          isFilteredErrorMessageShown = true; // Prevent further error messages for filteredAddedDevice
        }
        continue; // Skip this location if the filtered condition is met
      }

      if (isFromWorkPlaceItems) {
        const workPlaceItem = location?.workPlaceItems?.find((wpi: any) => wpi?.deviceTypeId === record?.id);
        const pieceCount = workPlaceItem?.piece ?? 1;

        const deviceData = {
          ...record,
          workPlace: location,
          workPlaceId: location?.id,
          device: { ...record },
          deviceTypeId: record.id,
          agent: agent,
          agentId: agent?.id,
          systemType: systemType,
          systemTypeId: systemType?.id,
          metadata: {
            deviceType: { price: record?.price },
          },
          details: pmAdditionalAct.equipmentTab.details,
          unitMeasure: 'buc',
          laborPrice: record?.laborPricePM * pieceCount,
          laborTime: record?.laborTimePM * pieceCount,
          piece: pieceCount,
        };

        dispatch(addPmAdditionalWorkPlaceItem(deviceData));
      } else {
        form.setFieldsValue({
          ...record,
          details: pmAdditionalAct.equipmentTab.details,
          laborTimePMTotal: record?.totalLaborsTimePM,
          laborPricePMTotal: record?.totalLaborsPricePM,
          unitMeasure: 'buc',
          piece: searchRecomandationPieceNumber ?? 1,
        });

        const newItem = {
          id: '',
          offerWorkPlaceId: '',
          workPlace: location,
          workPlaceId: location?.id,
          agent: pmAdditionalAct.equipmentTab.agent,
          agentId: pmAdditionalAct.equipmentTab.agentId,
          systemType: pmAdditionalAct.equipmentTab.systemType,
          systemTypeId: pmAdditionalAct.equipmentTab.systemTypeId,
          device: { ...record },
          deviceTypeId: record.id,
          pmOfferWorkPlaceMetadata: {},
          period: pmAdditionalAct.equipmentTab.period,
          laborPrice: record.laborPricePM,
          laborTime: record.laborTimePM,
          unitMeasure: record.unitMeasure ?? 'buc',
          isAnotherProvider: record.isAnotherProvider ?? false,
          interventionPerSystemType: pmAdditionalAct.equipmentTab.interventionPerSystemType,
          interventionPriceOnRequest: pmAdditionalAct.equipmentTab.interventionPriceOnRequest,
          addition: record.addition,
          piece: searchRecomandationPieceNumber ?? 1,
          metadata: { deviceType: { price: record.price } },
          price: Math.round(
            record.price * (searchRecomandationPieceNumber ?? 1) +
              ((record.price * record.addition) / 100) * (searchRecomandationPieceNumber ?? 1)
          ),
          details: pmAdditionalAct.equipmentTab.details,
        };

        dispatch(addPmAdditionalWorkPlaceItem(newItem));
      }
    }

    message.success(
      <span>
        <span className='font-weight-bold'>{record?.name}</span> a fost adăugat.
      </span>
    );
  };

  const handleSelectAgent = (value: string) => {
    const agent = agents.find((awp: any) => awp?.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      agent: agent,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'agentId', value: agent?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'agent', value: agent ?? null }));
  };

  const handleSystemType = (value: string) => {
    const systemType = systemTypes.find((st: any) => st.name == value);

    const fieldsValue = {
      ...form.getFieldsValue(true),
      systemType: systemType,
      systemTypeId: systemType?.id,
    };
    form.setFieldsValue(fieldsValue);
    dispatch(updateEquipmentTab({ field: 'systemTypeId', value: systemType?.id ?? null }));
    dispatch(updateEquipmentTab({ field: 'systemType', value: systemType ?? null }));

    setFiltredDeviceTypes(deviceTypes.filter((dt: any) => dt.systemTypeId == systemType.id));
  };

  const handleSearchInDeviceTable = (value: string, recomandationPieceNumber: number) => {
    setSearchTable(value);
    setRecomandationPieceNumber(recomandationPieceNumber);
    const filtered = deviceTypes
      ?.filter((device: any) => device.systemTypeId === selectedSystemTypeId)
      .filter(
        (device: any) =>
          (searchRecomandationPieceNumber >= device?.minRecomandation &&
            searchRecomandationPieceNumber <= device?.maxRecomandation &&
            device.name.toLowerCase().includes(value.toLowerCase())) ||
          device.model.toLowerCase().includes(value.toLowerCase()) ||
          device.producer.toLowerCase().includes(value.toLowerCase()) ||
          device.provider.toLowerCase().includes(value.toLowerCase()) ||
          device.price.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborTimeSM.toString().toLowerCase().includes(value.toLowerCase()) ||
          device.laborPriceSM.toString().toLowerCase().includes(value.toLowerCase())
      );

    setFiltredDeviceTypes(filtered);
  };

  const handleChangeDetails = (value: any) => {
    dispatch(updateEquipmentTab({ field: 'details', value: value }));
  };

  const handleSearchTermChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleExistentSystemType = async (systemName: string) => {
    const systemType = systemTypes.find((st: any) => st.name === systemName);

    pmAdditionalAct?.location?.forEach((location: any) => {
      const locationItems =
        location?.workPlaceItems?.filter((workPlaceItem: any) => workPlaceItem?.systemTypeId === systemType?.id) || [];

      locationItems.forEach((workPlaceItem: any) => {
        const findedDevice = {
          ...deviceTypes.find((dt: any) => dt.id === workPlaceItem?.deviceTypeId),
          isAnotherProvider: workPlaceItem?.isAnotherProvider ?? false,
        };

        // Check if the device is already added for this location
        const isDeviceAlreadyAdded = addedDevices.some(
          (ad: any) => ad.deviceTypeId === findedDevice.id && ad.workPlaceId === location.id
        );

        if (isDeviceAlreadyAdded) {
          // If the device is already in addedDevices, show error message for this specific device
          message.error(
            <span>
              The device <strong>{findedDevice.name}</strong> is already added at location{' '}
              <strong>{location.name}</strong>.
            </span>,
            5
          );
          return; // Skip adding this device
        }

        // Prepare device data for dispatch
        const pieceCount = workPlaceItem?.piece ?? 1;
        const deviceData = {
          ...findedDevice,
          workPlace: location,
          workPlaceId: location.id,
          device: { ...findedDevice },
          deviceTypeId: findedDevice.id,
          agent: pmAdditionalAct.equipmentTab.agent ?? location?.contactPersons[0],
          agentId: pmAdditionalAct.equipmentTab.agentId ?? location?.contactPersons[0]?.id,
          systemType: systemType,
          systemTypeId: systemType?.id,
          metadata: {
            deviceType: { price: findedDevice?.price },
          },
          details: pmAdditionalAct.equipmentTab.details,
          period: pmAdditionalAct.equipmentTab.period || 'lunar',
          unitMeasure: 'buc',
          laborPrice: findedDevice?.laborPricePM!,
          laborTime: findedDevice?.laborTimePM! * pieceCount,
          piece: pieceCount,
        };

        // Dispatch the device data
        dispatch(addPmAdditionalWorkPlaceItem(deviceData));

        // Show success message for this specific device
        message.success(
          <span>
            The device <strong>{findedDevice.name}</strong> has been successfully added at location{' '}
            <strong>{location.name}</strong>.
          </span>,
          5
        );
      });
    });
  };

  const handleLocationChange = (value: any) => {
    const selectedLocations = workPlaces.filter((w: any) => value.includes(w.name));
    dispatch(updateField({ field: 'location', value: selectedLocations }));
    updateSelectAllState(value);
  };

  const handleSelectAllChange = (e: any) => {
    const { checked } = e.target;
    const selectedLocations = checked ? workPlaces : [];
    dispatch(updateField({ field: 'location', value: selectedLocations }));
    setCheckAll(checked);
    setIndeterminate(false);
  };

  const updateSelectAllState = (selected: any) => {
    if (selected.length === workPlaces?.length) {
      setCheckAll(true);
      setIndeterminate(false);
    } else if (selected.length > 0) {
      setCheckAll(false);
      setIndeterminate(true);
    } else {
      setCheckAll(false);
      setIndeterminate(false);
    }
  };

  const deviceTableColumns: Column[] = [
    {
      title: 'Device Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'System Type Id',
      dataIndex: 'systemTypeId',
      key: 'systemTypeId',
      hidden: true,
    },
    {
      title: 'Imagine',
      dataIndex: 'imageLink',
      key: 'imageLink',
      render: (record: any) =>
        record[0] ? <img src={record[0]} alt='No Image' style={{ width: '100px', height: 'auto' }} /> : 'No image',
      fixed: 'left',
    },
    {
      title: 'Denumire',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => (
        <Tooltip title={text}>
          <div className='ellipsis-cell'>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'System Type',
      dataIndex: ['systemType', 'name'],
      key: 'systemTypeName',
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Timp Manopera SM (Minute)',
      dataIndex: 'laborTimeSM',
      key: 'laborTimeSM',
    },
    {
      title: 'Pret Manopera SM',
      dataIndex: 'laborPriceSM',
      key: 'laborPriceSM',
    },
    {
      title: 'Producator',
      dataIndex: 'producer',
      key: 'producer',
    },
    {
      title: 'Furnizor',
      dataIndex: 'provider',
      key: 'provider',
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: 'Actiune',
      dataIndex: '',
      key: 'actions',
      fixed: 'right',
      render: (record: any) => {
        const locationId = form.getFieldValue('location')?.id;
        const isDeviceAlreadyAdded = addedDevices?.some(
          (item: any) => item.deviceId === record.id && item.workPlaceId === locationId
        );

        return (
          <Button
            onClick={() => handleAddDevice(record)}
            disabled={
              isDeviceAlreadyAdded ||
              !(
                pmAdditionalAct?.location?.length > 0 &&
                pmAdditionalAct?.equipmentTab?.agentId != undefined &&
                pmAdditionalAct?.equipmentTab?.systemTypeId != undefined
              )
            }
            type='primary'
          >
            Adauga
          </Button>
        );
      },
      width: 10,
    },
  ];

  // Card rendering
  const renderCards = (filtredDeviceTypes: any, handleAddDevice: (device: any) => void, pmAdditionalAct: any) => (
    <div className='cardContainer'>
      {filtredDeviceTypes.map((device: any) => (
        <div className='device-card' key={device.id}>
          <img
            src={device.imageLink && device.imageLink[0] ? device.imageLink[0] : ''}
            alt='Device'
            className='cardImage'
          />
          <div className='cardContent'>
            <p>
              <strong>Denumire:</strong> {device.name}
            </p>
            <p>
              <strong>Model:</strong> {device.model}
            </p>
            <p>
              <strong>Pret:</strong> {device.price}
            </p>
          </div>
          <button
            className='addButton'
            onClick={() => handleAddDevice(device)}
            disabled={
              !(
                pmAdditionalAct?.location?.length > 0 &&
                pmAdditionalAct?.equipmentTab?.agentId !== undefined &&
                pmAdditionalAct?.equipmentTab?.systemTypeId !== undefined &&
                pmAdditionalAct?.equipmentTab?.period !== undefined
              )
            }
          >
            Adauga
          </button>
        </div>
      ))}
    </div>
  );
  // Table rendering
  const renderTable = () => (
    <CustomTable initialDataSource={filtredDeviceTypes} columns={deviceTableColumns} rowKey='id' />
  );

  return (
    <>
      <Form form={form} layout='vertical' className='form-container'>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['location', 'name']} label='Select Location'>
              <Select
                mode='multiple'
                allowClear
                placeholder='Selecteaza locatie'
                value={pmAdditionalAct.location?.map((loc: any) => loc?.name)} // Ensure the value is an array of strings
                onChange={handleLocationChange}
                filterOption={handleFilter}
                style={{ width: '100%' }}
              >
                <Option key='select-all' disabled>
                  <Checkbox indeterminate={indeterminate} onChange={handleSelectAllChange} checked={checkAll}>
                    Select All
                  </Checkbox>
                </Option>
                {workPlaces
                  ?.filter((location: any) => location?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()))
                  .map((location: any, index: any) => (
                    <Option key={index} value={location?.name}>
                      {location?.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['agent', 'name']} label='Persoana Contact'>
              <AutoComplete
                placeholder='Select an agent'
                onSelect={handleSelectAgent}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {agents?.map((a: any, index: any) => (
                  <Option key={index} value={a?.name}>
                    {a?.name} - {a?.role}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>
          {pmAdditionalAct.location.length > 0 && (
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item name='details' label='Detalii situare sistem'>
                <Input placeholder='Ex: Etaj 2, camera A2' onChange={(e) => handleChangeDetails(e.target.value)} />
              </Form.Item>
            </Col>
          )}

          <Col xs={24} sm={12} md={12} lg={8}>
            <Form.Item name={['systemType', 'name']} label='Type of System'>
              <AutoComplete
                placeholder='Select a system'
                onSelect={handleSystemType}
                onChange={() => handleSearchTermChange}
                filterOption={handleFilter}
                value={searchTerm}
              >
                {systemTypes?.map((systemType: any, index: any) => (
                  <Option key={index} value={systemType.name}>
                    {systemType.name}
                  </Option>
                ))}
              </AutoComplete>
            </Form.Item>
          </Col>

          {pmAdditionalAct.location.length > 0 && pmAdditionalAct.equipmentTab.agentId != undefined && (
            <Col xs={24} sm={12} md={12} lg={8}>
              <Form.Item
                name='existentSystem'
                label={`Tipuri de sistem existente pe ${
                  pmAdditionalAct.location.length > 0 ? 'locatiile selectate' : 'locatia selectata'
                }`}
              >
                <AutoComplete placeholder='Select a system' onSelect={handleExistentSystemType}>
                  {Array.from(
                    new Map(
                      pmAdditionalAct.location
                        ?.flatMap((loc: any) => loc.workPlaceItems) // Flatten all workPlaceItems
                        ?.map((item: any) => [
                          item.systemTypeId, // Key by systemTypeId
                          systemTypes.find((st: any) => st.id === item.systemTypeId)?.name, // Map to systemTypeName
                        ])
                    ).values() // Extract unique values
                  )
                    ?.filter(Boolean) // Remove undefined/null
                    ?.map((systemTypeName: any, index: number) => (
                      <Option key={index} value={systemTypeName}>
                        {systemTypeName}
                      </Option>
                    ))}
                </AutoComplete>
              </Form.Item>
            </Col>
          )}
        </Row>
        {deviceTypes?.length > 0 ? (
          <div className='add-equipment-search-number-line'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <InputNumber
                  placeholder='Introduceti numarul de bucati'
                  value={searchRecomandationPieceNumber}
                  min={1}
                  onChange={(value) => handleSearchInDeviceTable(searchTable, value ?? 1)}
                  className='add-equipment-number-input'
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <SearchInput
                  placeholder='Search'
                  value={searchTable}
                  onChange={(e) => handleSearchInDeviceTable(e.target.value, searchRecomandationPieceNumber)}
                  style={{ width: '100%', marginBottom: '10px' }}
                  autoFocus={true}
                />
              </Col>
            </Row>
            <div>{isMobile ? renderCards(filtredDeviceTypes, handleAddDevice, pmAdditionalAct) : renderTable()}</div>
          </div>
        ) : null}
      </Form>
    </>
  );
};

export default AddEquipmentTab;
